import React, {PureComponent} from 'react'
import Trend from 'react-trend'
import Theme, {mediaQueries} from 'Theme'

interface Props {
  data?: number[]
}

class GraphLine extends PureComponent<Props, object> {
  render() {
    const {data} = this.props
    const placeholder = Array.from({length: 20}, () =>
      Math.floor(Math.random() * 10)
    )
    return (
      <Trend
        autoDraw
        data={data || placeholder}
        stroke={Theme.color.primary}
        strokeOpacity={data && data.length > 2 ? 1 : 0.1}
        strokeWidth={3}
        padding={Theme.common.size.space}
        smooth={true}
        radius={20}
      />
    )
  }
}

export default GraphLine



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/GraphLine.tsx